import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { parseLink } from 'redux/modules/parsedLinks';
import moment from 'moment';
import { validateTargeting } from 'redux/modules/ads';
import { approveReusedAd, tiePostToAd } from 'redux/modules/adsPlanner';
import { deeplinkIntoAdsBuilder, getAdBuilderFormat, getFBAdPreview } from 'redux/modules/adBuilder';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { AdTypeIcon, Modal, PostListContent } from 'components';
import AdPlanIframePreviewWrap from './AdPlanIframePreviewWrap';
import * as styles from './AdsPlanStep2.scss';
import { pushSavedAudience } from 'redux/modules/ads';
var AdsPlanStep2 = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    parsedLinks: state.parsedLinks,
    selectedTimezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    },
    adAccountId: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId].adAccountId : null,
    theme: state.theme,
    savedAudiences: state.ads.savedAudiences
  };
}, {
  approveReusedAd: approveReusedAd,
  deeplinkIntoAdsBuilder: deeplinkIntoAdsBuilder,
  getAdBuilderFormat: getAdBuilderFormat,
  getFBAdPreview: getFBAdPreview,
  parseLink: parseLink,
  pushSavedAudience: pushSavedAudience,
  tiePostToAd: tiePostToAd,
  validateTargeting: validateTargeting
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlanStep2, _Component);

  var _super = _createSuper(AdsPlanStep2);

  function AdsPlanStep2(props) {
    var _this;

    _classCallCheck(this, AdsPlanStep2);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderCategoryHeader", function (cat, pastMonth) {
      var numAdsCreated = 0;
      cat.AdsPlannerAds.forEach(function (ad) {
        var isBuilt = ad.createdInternalAdId || ad.createdFacebookAdId || cat.type === 'CUSTOM_POSTS' && ad.PostAdvertisement && ad.PostAdvertisement.id;

        if (isBuilt) {
          numAdsCreated++;
        }
      });
      var allAdsCreated = cat.AdsPlannerAds.length === numAdsCreated;
      var totalColorClass = allAdsCreated ? 'green' : 'red';
      return /*#__PURE__*/React.createElement("div", {
        className: styles.categoryHeader
      }, /*#__PURE__*/React.createElement(AdTypeIcon, {
        adType: cat.type,
        source: "adsPlanner"
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.headerTitle
      }, cat.type === 'CUSTOM_POSTS' || cat.type === 'SUBSCRIBED_POSTS' ? 'BOOSTS - ' : '', _.startCase(cat.type)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderIconMenu", function (cat, ad) {
      return /*#__PURE__*/React.createElement(IconMenu, {
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, {
          style: {
            height: 20,
            padding: 0
          }
        }, /*#__PURE__*/React.createElement(MoreVertIcon, null))
      }, /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Create New Post",
        onClick: function onClick() {
          _this.props.onBuildAd(_this.props.adsPlan, cat, ad);
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Select Scheduled Post",
        onClick: function onClick() {
          _this.setState({
            currentAdId: ad.id,
            currentAdsPlanId: cat.AdsPlannerId,
            showCustomPostPicker: true
          });
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCategoryRows", function (cat, pastMonth) {
      return cat.AdsPlannerAds.map(function (ad, idx) {
        var isCustomPostBoost = cat.type === 'CUSTOM_POSTS';
        var boostIsBuilt = isCustomPostBoost && ad.PostAdvertisement && ad.PostAdvertisement.id;
        var reusingPreviousAd = !!ad.PreviousAdsPlannerAds.length;
        var adIsBuilt = ad.createdInternalAdId || ad.createdFacebookAdId;
        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: 6
          },
          key: ad.id
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.categoryRow,
          key: idx
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.rowTitle
        }, !isCustomPostBoost && /*#__PURE__*/React.createElement("span", {
          style: {
            fontStyle: 'italic'
          }
        }, reusingPreviousAd ? 'Reuse - ' : 'New - '), ad.name), ' '), /*#__PURE__*/React.createElement("div", {
          className: styles.categoryRow,
          key: idx * 100 + 1
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.rowBudget
        }, _this.props.formatCurrency(ad.budget)), (!!adIsBuilt || !!boostIsBuilt) && !pastMonth && /*#__PURE__*/React.createElement("span", {
          className: styles.buildLink,
          onClick: function onClick() {
            _this.setState({
              previewModalAdId: cat.type === 'CUSTOM_POSTS' ? ad.id : ad.createdFacebookAdId,
              showAdPreviewModal: true,
              previewModalCategoryType: cat.type
            });
          }
        }, "Preview"), !boostIsBuilt && isCustomPostBoost && !pastMonth && /*#__PURE__*/React.createElement("span", {
          className: styles.buildLink
        }, _this.renderIconMenu(cat, ad))));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCustomPostCards", function (upcomingCustomPosts, customPosts) {
      upcomingCustomPosts = upcomingCustomPosts.filter(function (post) {
        return !post.id.includes('group');
      });

      if (!!customPosts.length && !upcomingCustomPosts.length) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            color: '#333',
            fontSize: 16,
            padding: 24
          }
        }, "There are no upcoming posts.");
      } else if (!customPosts.length) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            color: '#333',
            fontSize: 16,
            padding: 24
          }
        }, "There are no custom posts for this month yet.");
      }

      var customPostAds = _this.props.adsPlan && _this.props.adsPlan.AdsPlannerCategories ? _this.props.adsPlan.AdsPlannerCategories.filter(function (cat) {
        return cat.type === 'CUSTOM_POSTS';
      })[0] : null;
      var customPostCards = upcomingCustomPosts.map(function (post, index) {
        var postAlreadyBoosted = false;

        if (customPostAds && customPostAds.AdsPlannerAds && customPostAds.AdsPlannerAds.length) {
          customPostAds.AdsPlannerAds.forEach(function (ad) {
            if (ad.PostAdvertisement && ad.PostAdvertisement.PostId && parseInt(ad.PostAdvertisement.PostId) === parseInt(post.id)) {
              postAlreadyBoosted = true;
            }
          });
        }

        var postCardStyle = {
          border: '1px solid #777',
          boxShadow: 'none'
        };

        if (postAlreadyBoosted) {
          postCardStyle.opacity = 0.75;
        }

        if (_this.state.selectedPostCard === index) {
          postCardStyle.border = "3px solid ".concat(_this.props.theme.colors.secondaryColor);
        }

        var postEventWrapperStyle = {
          border: 'none',
          boxShadow: 'none'
        };
        var publishAtTime = moment.utc(post.publishAt).add(_this.props.selectedTimezone.utc_offset.hours, 'hours').add(_this.props.selectedTimezone.utc_offset.minutes || 0, 'minutes');
        var imageUrl = post.S3Files && post.S3Files.length ? [post.S3Files[0].fullyQualifiedUrl] : null;
        var postType = 'textPost';

        if (post.linkUrl) {
          postType = 'linkPost';
        } else if (imageUrl) {
          postType = 'imagePost';
        } else if (post.videoUrl) {
          postType = 'videoPost';
        }

        if (postType === 'linkPost') {
          if (_this.props.parsedLinks[post.linkUrl]) {
            post.linkData = _this.props.parsedLinks[post.linkUrl];
          } else {
            _this.props.parseLink(post.linkUrl);
          }
        }

        var belowMessageContent = postType === 'linkPost' ? /*#__PURE__*/React.createElement("a", {
          href: post.linkUrl,
          style: {
            color: '#1f5180',
            textDecoration: 'none',
            fontSize: 13
          },
          target: "_blank"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-link",
          style: {
            marginRight: 6
          }
        }), "Link Post") : postType === 'videoPost' ? /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 13
          }
        }, "Video Post") : null;
        var message = post.message ? post.message : postType === 'linkPost' && post.linkData ? post.linkData.parsing ? 'Loading...' : post.linkData.description : 'No message';
        var image = imageUrl;

        if (postType === 'linkPost' && !imageUrl) {
          if (post.linkData && !post.linkData.parsing && post.linkData.imageUrl) {
            image = post.linkData.imageUrl;
          }
        }

        var videoUrl = post.videoUrl;
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          onClick: function onClick() {
            _this.setState({
              selectedPostCard: index,
              selectedPost: post,
              selectedStartTime: publishAtTime.add(1, 'hour'),
              selectedEndTime: publishAtTime.add(1, 'day')
            });
          },
          style: _this.state.selectedPost && post && _this.state.selectedPost.id === post.id ? {
            border: '2px solid #1f5180',
            borderRadius: 4,
            marginBottom: 16
          } : {
            border: '1px solid #999999',
            borderRadius: 4,
            cursor: 'pointer',
            marginBottom: 16
          }
        }, /*#__PURE__*/React.createElement(PostListContent, {
          style: {
            padding: 12
          },
          videoUrl: videoUrl,
          image: image,
          message: message,
          belowMessageContent: belowMessageContent
        }));
      });
      return customPostCards;
    });

    _this.state = {
      selectedPostCard: 9999,
      showApproveModal: false,
      showCustomPostPicker: false,
      showAdPreviewModal: false,
      previewModalAdId: null,
      previewModalCategoryType: '',
      currentAdInApproveModal: {
        createdFacebookAdId: 0,
        AdsPlannerCategoryId: 0
      },
      approvingReusedAd: false
    };
    return _this;
  }
  /** *********************************************************
   RENDER
   ***********************************************************/


  _createClass(AdsPlanStep2, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adsPlan = _this$props.adsPlan,
          customPosts = _this$props.customPosts;
      var upcomingCustomPosts = customPosts.filter(function (cp) {
        return moment(cp.publishAt).isAfter(moment());
      });
      var cats = adsPlan.AdsPlannerCategories.sort(function (a, b) {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
      });
      var postCats = cats.filter(function (cat) {
        return cat.type === 'CUSTOM_POSTS' || cat.type === 'SUBSCRIBED_POSTS';
      }).filter(function (c) {
        return c;
      });
      var adCats = cats.filter(function (cat) {
        return cat.type !== 'CUSTOM_POSTS' && cat.type !== 'SUBSCRIBED_POSTS' && !!cat.AdsPlannerAds.length;
      }).filter(function (c) {
        return c;
      });
      var customPostPickerActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "cancelbtn",
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            showCustomPostPicker: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        key: "selectbtn",
        label: "Select",
        disabled: !this.state.selectedPost,
        secondary: true,
        onClick: function onClick() {
          _this2.props.tiePostToAd(_this2.props.organization.id, _this2.state.currentAdsPlanId, _this2.state.selectedPost.id, _this2.state.currentAdId, _this2.state.selectedStartTime, _this2.state.selectedEndTime);

          _this2.setState({
            showCustomPostPicker: false
          });
        }
      })];
      var approveModalButtons = [/*#__PURE__*/React.createElement(RaisedButton, {
        key: "cancelbtn",
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            showApproveModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        key: "editbtn",
        secondary: true,
        label: "Edit",
        onClick: function onClick() {
          _this2.setState({
            showApproveModal: false
          });

          var ad = _this2.state.currentAdInApproveModal;
          var category = _this2.state.currentCategoryInApproveModal;
          var catType = category.type;
          var numDaysBudgetWillLast = Math.floor(ad.budget / 200);
          var adEnd;

          if (moment(adsPlan.dateStart).isBefore(moment())) {
            // plan starts before now(), so startDate will be now()
            if (moment().add(numDaysBudgetWillLast, 'days').isAfter(moment(adsPlan.dateEnd))) {
              // adding numDaysBudgetWillLast exceeds plan endDate so....
              adEnd = moment(adsPlan.dateEnd).toDate();
            } else {
              adEnd = moment().add(numDaysBudgetWillLast, 'days').toDate();
            } // END plan starts before now()

          } else {
            // plan starts in the future
            adEnd = moment(adsPlan.dateStart).add(numDaysBudgetWillLast, 'days').toDate();
          }

          _this2.props.getAdBuilderFormat(_this2.props.organization.id, ad.PreviousAdsPlannerAds[0].createdFacebookAdId).then(function (res) {
            return Promise.all([res, _this2.props.validateTargeting(res.data.targeting, _this2.props.adAccountId)]);
          }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                res = _ref2[0],
                validAudience = _ref2[1];

            var fakeSavedAudience = null;

            if (!validAudience) {
              alert('The target audience for this ad is no longer valid. You will need to use a saved audience or create a new one.');
            } else {
              fakeSavedAudience = {
                id: -1,
                name: "Original Ad's Targeting",
                FacebookTargetingConfigId: -1,
                OrganizationId: _this2.props.organization.id,
                createdAt: new Date(),
                updatedAt: new Date(),
                FacebookTargetingConfig: {
                  id: -1,
                  data: _objectSpread({}, res.data.targeting),
                  FacebookObjectId: -1,
                  createdAt: new Date(),
                  updatedAt: new Date()
                }
              };
            }

            _this2.props.deeplinkIntoAdsBuilder(_this2.props.organization.id, _objectSpread(_objectSpread({
              fromPlannedAd: ad,
              fromPlannedAdCategory: category,
              step: 2
            }, res.data.redux), {}, {
              adName: ad.name,
              adBudget: _this2.props.formatCurrency(ad.budget).replace('$', ''),
              minAdStart: moment(adsPlan.dateStart).toDate(),
              maxAdEnd: moment(adsPlan.dateEnd).toDate(),
              adStart: moment(adsPlan.dateStart).isBefore(moment()) ? moment().toDate() : moment(adsPlan.dateStart).toDate(),
              adEnd: adEnd,
              selectedAudienceTabKey: 'saved',
              'saved-audiences': fakeSavedAudience,
              reusedAdAudience: fakeSavedAudience,
              call_to_action: res.data.ad.creative.call_to_action_type
            }));

            browserHistory.push("/org/".concat(_this2.props.organization.id, "/create-ad/2"));
          });
        },
        style: {
          marginRight: 24
        }
      })];
      var plannedBoostAdsTotal = postCats ? postCats.reduce(function (accumulator, cat) {
        return accumulator + parseInt(cat.budget);
      }, 0) : 0;
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.pastMonth ? styles.pastMonth : ''
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, adCats.map(function (cat, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.categoryWrap,
          key: index
        }, _this2.renderCategoryHeader(cat, _this2.props.pastMonth), /*#__PURE__*/React.createElement("div", {
          className: styles.categoryRowWrap
        }, _this2.renderCategoryRows(cat, _this2.props.pastMonth)));
      })), plannedBoostAdsTotal > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: {
          borderTop: '1px solid #f1f1f1'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.categoryWrap
      }, this.renderCategoryHeader(postCats[0]), /*#__PURE__*/React.createElement("div", {
        className: styles.categoryRowWrap
      }, this.renderCategoryRows(postCats[0], this.props.pastMonth))), postCats && postCats[1] && /*#__PURE__*/React.createElement("div", {
        className: styles.categoryWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.categoryHeader
      }, /*#__PURE__*/React.createElement(AdTypeIcon, {
        adType: postCats[1].type,
        source: "adsPlanner"
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.headerTitle
      }, "BOOSTS - ", _.startCase(postCats[1].type)), /*#__PURE__*/React.createElement("span", {
        className: styles.headerBudget
      }, " ", postCats[1].SubscribedPostBoost.countOfPosts, " Posts")), /*#__PURE__*/React.createElement("div", {
        className: styles.categoryRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.rowTitle,
        style: {
          marginLeft: 30
        }
      }, postCats[1].SubscribedPostBoost.countOfPosts, " Posts to be boosted"), !!postCats[1].SubscribedPostBoost.countOfPosts && /*#__PURE__*/React.createElement("span", {
        className: styles.rowBudget
      }, this.props.formatCurrency(postCats[1].budget)), !!postCats[1].SubscribedPostBoost.countOfPosts && /*#__PURE__*/React.createElement("span", null, this.props.formatCurrency(postCats[1].SubscribedPostBoost.budgetPerPost), "/post")))), /*#__PURE__*/React.createElement(Modal, {
        title: "Choose A Custom Post To Boost",
        actions: customPostPickerActions,
        open: this.state.showCustomPostPicker,
        contentStyle: {
          width: '85%',
          maxWidth: 100000
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          padding: 12
        }
      }, this.renderCustomPostCards(upcomingCustomPosts, customPosts))), /*#__PURE__*/React.createElement(Modal, {
        open: this.state.showAdPreviewModal,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            previewModalCategoryType: '',
            previewModalAdId: null,
            showAdPreviewModal: false
          });
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          key: "closebtn",
          label: "Close",
          onClick: function onClick() {
            _this2.setState({
              previewModalCategoryType: '',
              previewModalAdId: null,
              showAdPreviewModal: false
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(AdPlanIframePreviewWrap, {
        adId: this.state.previewModalAdId,
        type: this.state.previewModalCategoryType
      })), /*#__PURE__*/React.createElement(Modal, {
        title: "Approve Or Edit An Existing Ad",
        actions: approveModalButtons,
        open: this.state.showApproveModal,
        contentStyle: {
          width: '85%',
          maxWidth: 100000
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginLeft: 20,
          marginRight: 20,
          padding: 12,
          overflowX: 'scroll'
        }
      }, this.state.currentAdInApproveModal.PreviousAdsPlannerAds && /*#__PURE__*/React.createElement(AdPlanIframePreviewWrap, {
        adId: this.state.currentAdInApproveModal.PreviousAdsPlannerAds[0].createdFacebookAdId,
        type: this.state.currentAdInApproveModal.AdsPlannerCategoryId
      }))));
    }
  }]);

  return AdsPlanStep2;
}(Component)) || _class);
export { AdsPlanStep2 as default };